module.exports = __webpack_public_path__ + "static/media/book_nation_header.d854768a.png";